import { Currency } from '@moment/trading-types/reference-data'

import { CURRENCY_SYMBOLS } from '@/shared/constants/international'
import {
  decimalToPercentage,
  formatCompactMoney,
  formatPercentage,
} from '@/utils/presentation/formatting'

export interface RuleBounds {
  min?: string
  max?: string
  target?: string
}

export const formatRuleWeight = (weight: number): string =>
  formatPercentage(decimalToPercentage(weight), {
    numDigits: 2,
    removeTrailingZeros: true,
  })

export const formatBoundMoney = (
  value: number,
  currency: string = Currency.USD,
): string =>
  formatCompactMoney(value, CURRENCY_SYMBOLS[currency] ?? '$').replace(
    /k$/,
    'K',
  )

export function formatRuleRange({
  min,
  max,
  target,
}: RuleBounds): string | null {
  if (min && max) return `${min} – ${max}`
  if (target) return `= ${target}`
  if (min) return `≥ ${min}`
  if (max) return `≤ ${max}`
  return null
}
